import React from "react";
import { useUnifiedService } from "../../utilities/contexts/UnifiedServiceContext";
import { ServiceStep } from "../../utilities/types/unified-services";
import { getDisplaySteps } from "../../utilities/helpers/serviceStepMapper";
import { RiUploadLine, RiEyeOffLine, RiRulerLine, RiLoader2Line, RiCheckLine, RiPriceTag3Line, RiSearchLine, RiTShirtLine, RiBookOpenLine } from "react-icons/ri";

const UnifiedStepIndicator: React.FC = () => {
  const { serviceInterface, serviceConfig } = useUnifiedService();
  const { currentStep } = serviceInterface;

  const displaySteps = getDisplaySteps(serviceConfig);

  const getStepIcon = (step: ServiceStep) => {
    switch (step) {
      case ServiceStep.GUIDE:
        return RiBookOpenLine;
      case ServiceStep.UPLOAD:
        return RiUploadLine;
      case ServiceStep.FACE_BLUR:
        return RiEyeOffLine;
      case ServiceStep.HEIGHT_INPUT:
        return RiRulerLine;
      case ServiceStep.PROCESSING:
        return RiLoader2Line;
      case ServiceStep.RESULTS:
        return getResultsIcon(serviceConfig.serviceId);
      default:
        return RiCheckLine;
    }
  };

  const getResultsIcon = (serviceId: string) => {
    switch (serviceId) {
      case "auto-tagging":
        return RiPriceTag3Line;
      case "visual-search":
        return RiSearchLine;
      case "garment-measurement":
        return RiTShirtLine;
      default:
        return RiCheckLine;
    }
  };

  return (
    <div className="flex justify-center w-full py-4 lg:py-8">
      <div className="flex justify-center w-full overflow-hidden max-w-80 md:max-w-none">
        {displaySteps.map((stepData, index) => {
          const IconComponent = getStepIcon(stepData.step);
          const isActive = currentStep === stepData.step;
          const isCompleted = stepData.index < displaySteps.findIndex((s) => s.step === currentStep);

          return (
            <div key={stepData.step} className="relative flex rounded-full items-center justify-center *:flex *:flex-col ">
              <div className={`flex flex-col items-center gap-1 lg:gap-2 min-w-14 md:min-w-16 lg:min-w-24 xl:min-w-40 ${isActive || isCompleted ? "text-primary" : "text-gray-400"}`}>
                {index !== displaySteps.length - 1 && <span className={`absolute top-4 lg:top-6 translate-x-1/2 w-full h-0.5 z-10 ${isActive || isCompleted ? "bg-primary" : "bg-gray-300"}`} />}

                <div
                  className={`size-8 lg:size-12 grid place-content-center border rounded-full z-20 ${
                    isActive || isCompleted ? "bg-primary border-primary text-white" : " bg-white text-gray-400 border-gray-300"
                  }`}
                >
                  <IconComponent className={`size-4 lg:size-6`} />
                </div>

                <span className="text-[10px] capitalize md:text-[12px] md:text-xs">{stepData.label}</span>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default UnifiedStepIndicator;
